// links to apps in the store
export const appStoreLink = 'https://apps.apple.com/app/sonect-easy-cash-withdrawal/id1185348506';
export const googlePlayLink = 'https://play.google.com/store/apps/details?id=ch.sonect.app';
